<template>
  <div class="period-selector">
    <span
      v-for="period in periodOptions"
      :key="period.value"
      class="period-option"
      :class="{ active: selectedPeriod === period.value }"
      @click="onPeriodClick(period.value)"
    >
      {{ $t(period.labelKey) }}
    </span>
  </div>
</template>

<script>
import { PERIODS, PERIOD_OPTIONS } from '../config/pricingConfig'

export default {
  name: 'PeriodSelector',

  props: {
    selectedPeriod: {
      type: String,
      default: PERIODS.ONE_YEAR,
      validator: value => Object.values(PERIODS).includes(value)
    }
  },

  data() {
    return {
      periodOptions: PERIOD_OPTIONS
    }
  },

  methods: {
    onPeriodClick(period) {
      if (period !== this.selectedPeriod) {
        this.$emit('period-change', period)
      }
    }
  }
}
</script>

<style scoped>
.period-selector {
  background: #f0ecf4;
  display: inline-flex;
  justify-content: space-between;
  padding: 5px;
  border-radius: 50px;
  width: 360px;
  max-width: 96%;
  margin-top: 4px;
  margin-bottom: 28px;
}

.period-option {
  border: none;
  background: transparent;
  padding: 10px 25px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  color: rgb(98, 36, 74);
  transition: all 0.3s ease;
  cursor: pointer;
  text-align: center;
  flex: 1;
  user-select: none;
  font-family: 'THICCCBOI', sans-serif;
}

.period-option.active {
  background: rgb(98, 36, 74);
  color: #fff;
}

.period-option:hover:not(.active) {
  background: rgba(107, 31, 77, 0.1);
}
</style>
